import * as React from "react";
import styled from "styled-components";
import {
  IBtnDefaultProps,
  mixinBtnCorporate,
  mixinBtnSmall,
  mixinResetBtnCss,
  mixinWithBtnPropsFn,
} from "./btn_mixin";

interface IProps
  extends IBtnDefaultProps,
    React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    > {}

const BtnCorporateSmallDefault: React.FC<IProps> = (props) => {
  const { icon, ...ButtonProps } = props;

  return <button {...ButtonProps} />;
};

const BtnCorporateSmall = styled(BtnCorporateSmallDefault)`
  ${mixinResetBtnCss}
  ${mixinBtnSmall}
  ${mixinBtnCorporate}
    
  ${(props) => mixinWithBtnPropsFn(props)}
`;

export default BtnCorporateSmall;

export const BtnCorporateSmall2 = styled(BtnCorporateSmallDefault)`
  ${mixinResetBtnCss}
  ${mixinBtnSmall}
  color: #9A8C64;
  background-color: transparent;
  font-size: 12px;
  font-weight: bold;
  ${(props) => mixinWithBtnPropsFn(props)}
`;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_corporate_small.tsx